import React, { useState } from 'react';

const QuickAddCompanyModal = ({ show, onClose, onSave }) => {
    const [company, setCompany] = useState({
        companyName: '',
        type: 'vendor',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        shipping: {
            addressType: 'shipping',
            addressLine: '',
            city: '',
            state: '',
            zip: ''
        }
    });
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, '');
        const phoneNumberLength = phoneNumber.length;
        
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    };

    const handlePhoneChange = (e) => {
        const formattedPhone = formatPhoneNumber(e.target.value);
        setCompany(prev => ({ ...prev, phone: formattedPhone }));
    };

    const handleAddressChange = (field, value) => {
        setCompany(prev => ({
            ...prev,
            shipping: {
                ...prev.shipping,
                [field]: value
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        
        try {
            const submitData = {
                companyName: company.companyName,
                type: 'vendor',
                firstName: company.firstName,
                lastName: company.lastName,
                phone: company.phone.replace(/[^\d]/g, ''),
                email: company.email,
                addresses: [{
                    addressType: 'shipping',
                    addressLine: company.shipping.addressLine,
                    city: company.shipping.city,
                    state: company.shipping.state,
                    zip: company.shipping.zip
                }]
            };

            await onSave(submitData);
            onClose();
        } catch (err) {
            setError('Failed to create vendor. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Quick Add Vendor</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                disabled={loading}
                            ></button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">
                                {error && (
                                    <div className="alert alert-danger">{error}</div>
                                )}
                                
                                <div className="mb-3">
                                    <label className="form-label">Company Name *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={company.companyName}
                                        onChange={(e) => setCompany({
                                            ...company,
                                            companyName: e.target.value
                                        })}
                                        required
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">First Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={company.firstName}
                                            onChange={(e) => setCompany({
                                                ...company,
                                                firstName: e.target.value
                                            })}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Last Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={company.lastName}
                                            onChange={(e) => setCompany({
                                                ...company,
                                                lastName: e.target.value
                                            })}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            value={company.phone}
                                            onChange={handlePhoneChange}
                                            placeholder="(555) 555-5555"
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={company.email}
                                            onChange={(e) => setCompany({
                                                ...company,
                                                email: e.target.value
                                            })}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Street Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={company.shipping.addressLine}
                                        onChange={(e) => handleAddressChange('addressLine', e.target.value)}
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={company.shipping.city}
                                            onChange={(e) => handleAddressChange('city', e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">State</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={company.shipping.state}
                                            onChange={(e) => handleAddressChange('state', e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">ZIP Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={company.shipping.zip}
                                            onChange={(e) => handleAddressChange('zip', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? 'Creating...' : 'Create Vendor'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default QuickAddCompanyModal;